import { useState } from "react";
import { CalendarClock, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

const fmtDt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export function MonthlySheetRow({ info, onChange }) {
  const [busy, setBusy] = useState(false);
  const toggle = async (v) => {
    onChange({ sheet_monthly_enabled: v });
    try { await api.put("/whatsapp/integration-info/schedule", { enabled: v }); toast.success(v ? "Invio mensile attivo (1° del mese, 07:00 UTC)" : "Invio mensile disattivato"); }
    catch { toast.error("Salvataggio non riuscito"); onChange({ sheet_monthly_enabled: !v }); }
  };
  const sendNow = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/whatsapp/integration-info/send-monthly-now");
      if (data.sent) { toast.success(`Scheda inviata a ${data.to}`); onChange({ sheet_last_sent_at: new Date().toISOString(), sheet_last_sent_to: data.to }); }
      else toast.warning(data.reason === "no_email" ? "Imposta l'email avvisi (Report → Email promemoria)" : `Non inviata: ${data.reason}`);
    } catch { toast.error("Invio non riuscito"); } finally { setBusy(false); }
  };
  return (
    <div className="bg-[#0A0E17] border border-[#1F2937] rounded-lg px-3 py-2 flex flex-wrap items-center gap-x-3 gap-y-1.5" data-testid="info-monthly-sheet">
      <CalendarClock className="h-3.5 w-3.5 text-slate-400" />
      <div className="flex-1 min-w-[200px]">
        <p className="text-xs text-slate-200">Invia la scheda tecnica ogni mese <span className="text-slate-500">· 1° del mese, 07:00 UTC, a {info.default_email || "email avvisi/admin"}</span></p>
        <p className="text-[10px] text-slate-500" data-testid="info-monthly-last">Ultimo invio automatico: {info.sheet_last_sent_at ? `${fmtDt(info.sheet_last_sent_at)} → ${info.sheet_last_sent_to}` : "mai"}</p>
      </div>
      <Switch checked={!!info.sheet_monthly_enabled} onCheckedChange={toggle} data-testid="info-monthly-toggle" className="data-[state=checked]:bg-[#10B981]" />
      <Button size="sm" variant="outline" onClick={sendNow} disabled={busy} data-testid="info-monthly-send-now" className="h-6 px-2 text-[11px] border-[#1F2937] text-slate-300">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3 mr-1" />} Invia ora
      </Button>
    </div>
  );
}
